import { Title } from "@mantine/core";
import { Controller, type Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormFieldController } from "../../../../../../../components/BuildingBlocks/Forms/Controllers/FormFieldController";
import { DayInYearInput } from "../../../../../../../components/BuildingBlocks/Forms/FormFields/DayInYearInput/DayInYearInput";
import { CustomFormFieldWrapper } from "../../../../../../../components/BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import type { Paragraph6ContractFormFields } from "../../../../../Paragraph6.types";
import { PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA } from "../Paragraph6ContractForm.constants";

interface FristenProps {
  control: Control<Paragraph6ContractFormFields>;
  isStaff?: boolean;
}

function Fristen({ control, isStaff }: FristenProps) {
  const { t } = useTranslation();

  return (
    <section>
      <Title mt="lg" order={6}>
        Vertragsbedingungen
      </Title>
      <FormFieldController
        control={control}
        data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.signing_date}
      />
      <FormFieldController
        control={control}
        data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.begin}
      />
      <FormFieldController
        control={control}
        data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.minimum_term}
      />
      <FormFieldController
        control={control}
        data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.end}
      />
      <FormFieldController
        control={control}
        data={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.billing_method_and_period}
      />
      <Controller
        control={control}
        name={PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.billing_period_start.name}
        render={({ field, fieldState: { error } }) => (
          <CustomFormFieldWrapper
            {...PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.billing_period_start}
            error={error}
          >
            <DayInYearInput error={error?.message} {...field} />
          </CustomFormFieldWrapper>
        )}
        rules={{ required: t("errors.Required") }}
      />
      {isStaff && (
        <FormFieldController
          control={control}
          data={
            PARAGRAPH_6_CONTRACT_FORM_INPUT_DATA.split_billing_period_at_year_boundary
          }
        />
      )}
    </section>
  );
}

export { Fristen };
